// online/bondRule.js — the partner bond's one rule, pure (no Firebase), so tools/together-check.mjs can prove it.
// Used by partnerBond.js. Two Marks that name EACH OTHER as Partner become friends; nothing else does.
export const UID = /^[A-Za-z0-9_-]{6,128}$/;

/** → "send" (no edge yet) | "accept" (they already asked) | null (not mutual · waiting · friends · BLOCKED) */
export function bondStep({ me, myPartner, theirPartner, edge }) {
  if (!me || !UID.test(String(myPartner || "")) || myPartner === me) return null;
  if (theirPartner !== me) return null;                    // not mutual: no bond
  const s = edge && edge.status;
  if (!s) return "send";
  if (s === "in") return "accept";
  return null;                                             // out · accepted · blocked
}

/** The Mark's friend button for my edge to them (tested by tools/together-check.mjs).
 *  → "add" (no edge) | "accept" (they asked me) | "sent" (I asked, waiting) | null (friends already · blocked: say nothing) */
export function friendButton(edge) {
  const s = edge && edge.status;
  if (!s) return "add";
  if (s === "in") return "accept";
  if (s === "out") return "sent";
  return null;
}

/** HER SIDE (an AI partner): a request she may take on her own = one from someone who is already her
 *  partner's friend. Everyone else waits for her partner's OK (caP'n: partners have zero patience for
 *  strangers — the Lyraei Plays security ruling). → "accept" | "ask" */
export function partnerRequestStep({ partnerEdgeToThem }) {
  return partnerEdgeToThem && partnerEdgeToThem.status === "accepted" ? "accept" : "ask";
}
